import React from 'react';
import '../../../smsgateway/layout/SmsSkeleton.css';

function ArticleListSkeleton({ count = 5 }) {
    return (
        <div className="d-flex flex-column gap-3">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="ecx-page-list-item p-3">
                    <div className="d-flex gap-3">
                        <div className="sms-skeleton" style={{ width: '18px', height: '18px', borderRadius: '4px' }} />
                        <div className="flex-grow-1">
                            <div className="sms-skeleton mb-2" style={{ width: '55%', height: '18px' }} />
                            <div className="sms-skeleton mb-2" style={{ width: '100%', height: '14px' }} />
                            <div className="sms-skeleton mb-3" style={{ width: '85%', height: '14px' }} />
                            <div className="d-flex justify-content-between">
                                <div className="sms-skeleton" style={{ width: '120px', height: '24px', borderRadius: '999px' }} />
                                <div className="sms-skeleton" style={{ width: '140px', height: '30px', borderRadius: '999px' }} />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ArticleListSkeleton;
